import type { ModuleConfiguration, ModulePageConfiguration } from 'c-data-layer';
import { config } from 'c-data-layer';
import type { AllEntities, BaseEntity } from 'c-sdk';
import type { CommonState } from 'c-types';
import type { DrawerConfiguration } from 'c-wrapper/Types/DrawerConfiguration';
import type {
    ModuleSystemSearchConfiguration,
    ParsedUnTranslatedSystemSearchConfiguration,
    SystemSearchEntityResource,
    SystemSearchResource,
    UnTranslatedSystemSearchResourceOrEntity,
} from './Modules/SystemSearch/types';

export type Config<RootState = CommonState> = Omit<
    ModuleConfiguration<RootState, { [key in keyof AllEntities]: AllEntities[key] }>,
    'mergeFunction' | 'pages' | 'navigation'
> & {
    systemSearch: ModuleSystemSearchConfiguration;
    systemSearchParsed?: ParsedUnTranslatedSystemSearchConfiguration;
    mergeFunction: (config: Config, config2Merge: Config) => void;
    navigation: DrawerConfiguration;
    pages: (PageConfig | PageEntityConfig<BaseEntity>)[];
    widgets?: WidgetConfig[];
};

export type PageEntityConfig<Entity extends BaseEntity> = PageConfig & {
    systemSearch: SystemSearchEntityResource<Entity>;
};

export type PageConfig = ModulePageConfiguration & {
    /**
     * Optionally set to disable the content area scrolling on breakpoints considered to be desktop.
     *
     * This will allow you to easily set page content that stretches no further than the bottom of the page.
     */
    disableDesktopContentScrolling?: boolean;
    systemSearch: UnTranslatedSystemSearchResourceOrEntity<SystemSearchResource>;
    // pageTours?: { [id: string]: CRMTourConfig<TranslationPath> };
};

export type WidgetConfig = {
    id: string;
    systemSearch: SystemSearchResource;
};

export default config as any as Config;
